import { useCallback, useState } from "react"
import { GetApp } from "../../App"
import { UnitSelect } from "../../Components/UnitSelect"
import { BlockField, BlockFieldInputs } from "../../Components/Block"
import { NumberInput } from "../../Components/Input"
import { PredefinedSelect } from "../../Components/PredefinedSelect"
import { ShipSingleRowDataItem } from "../../Components/ShipSingleRowDataItem"
import { IShipDataSteeringSystem } from "../../Types"

interface ShipDataSteeringSystemViewProps {
  data: IShipDataSteeringSystem;
  editable: boolean;
  index: number;
  onEdited?: () => void;
  removeSteeringSystem: () => void;
}

export function ShipDataSteeringSystemView({ data, editable, index, onEdited, removeSteeringSystem }: ShipDataSteeringSystemViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const namePrefix = `steeringSystems[${index}].`;

  { /* List for steeringtypes */ }
  // Initialize steeringtype with the value from data, or undefined if not present
  const [steeringType, setSteeringType] = useState<string | undefined>(data.steeringType);
  const predefinedTypes = ["bow_thruster", "stern_thruster", "self_steering", "windvane", "autopilot"];
  const selectSteeringType = useCallback((value?: string) => {
    setSteeringType(value);
    if (onEdited) {
      onEdited();
    }
  }, []);

  return (
    <ShipSingleRowDataItem namePrefix={namePrefix} id={data.id} rowClassName="block-row-last additional-steering-system-fields-row" onRemove={removeSteeringSystem}>
      <BlockField label={t("steering_type")} className="block_field_small_14">
        <PredefinedSelect value={steeringType} predefined={predefinedTypes} label={(v) => t(`steering_${v}`)} customValue={t("other")} name={`${namePrefix}steeringType`} onSelect={selectSteeringType} readOnly={!editable} />
      </BlockField>

      <BlockField label={t("manufacturer")} className="block_field_small_18">
        <input name={`${namePrefix}manufacturer`} defaultValue={data.manufacturer} onChange={onEdited} readOnly={!editable} />
      </BlockField>
      <BlockField label={t("model")} className="block_field_small_18">
        <input name={`${namePrefix}model`} defaultValue={data.model} onChange={onEdited} readOnly={!editable} />
      </BlockField>
      {/* </BlockRow>
    <BlockRow className="block-row-last additional-steering-system-fields-row"> */}
      <BlockField label={t("power")} className="block_field_small_8">
        <BlockFieldInputs>
          <NumberInput format="int" className="unit" name={`${namePrefix}power`} defaultValue={data.power} onChange={onEdited} readOnly={!editable} />
          <UnitSelect kind="power" name={`${namePrefix}powerUnit`} value={data.powerUnit} editable={editable} onChange={onEdited} />
        </BlockFieldInputs>
      </BlockField>
      <BlockField label={t("comment")}>
        <input name={`${namePrefix}comment`} defaultValue={data.comment} onChange={onEdited} readOnly={!editable} />
      </BlockField>
    </ShipSingleRowDataItem>
  );
}
